const NoReservations = () => (
  <div className="c7-account__dashboard__message">
    <p>You have not yet placed a reservation.</p>
  </div>
);

export default NoReservations;
